<template>
  <div class="sliderWrapper quiz_slider" ref="slider">
    <!-- <transition
      name="fade"
      appear
      v-if="showSlidePreBegin && !showLoader"
    >
      <div v-for="step in startingSteps" :key="`slide-${step}`" class="slide" v-if="step === currentStartingStep && showEndOrBeginning">
        <slot
          :name="step"
          
        ></slot>
      </div>
    </transition> -->

    <transition name="fade" appear v-if="!showEndOrBeginning && !showLoader">
      <div
        v-for="step in steps"
        :key="`slide-${step}`"
        class="slide"
        v-if="step === currentStep && !showEndOrBeginning"
      >
        <slot :name="step"></slot>
      </div>
    </transition>
    <transition name="fade" appear v-if="showSlidePostEnding && !showLoader">
      <div
        v-for="step in endingSteps"
        :key="`slide-${step}`"
        class="slide"
        v-if="step === currentEndingStep && showEndOrBeginning"
      >
        <slot :name="step"></slot>
      </div>
    </transition>
    <transition name="fade" v-if="showLoader">
      <div class="slide">
        <slot name="loader">loading...</slot>
      </div>
    </transition>
    <div class="stepButtons" v-if="siteSettings.sideButton">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="stepButton"
        :style="visitedSteps.has(step) ? visitedStyleObject : ''"
        @click="goToStep(step)"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { scrollToElement } from "../assets/js/helper";
export default {
  name: "SliderWrapper",
  props: {
    steps: {
      type: Array,
      required: true
    },
    endingSteps: {
      type: Array,
      required: true
    },
    startingSteps: {
      type: Array,
      required: true
    },
    currentEndingStep: {
      type: String,
      required: true
    },
    currentStartingStep: {
      type: String,
      required: true
    },
    currentStep: {
      type: String,
      required: true
    },
    showSlidePostEnding: {
      type: Boolean,
      required: true
    },
    showSlidePreBegin: {
      type: Boolean,
      required: true
    },
    showLoader: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      visitedSteps: new Set(),
      currentStepId: null
    };
  },
  computed: {
    ...mapState(["siteSettings"]),
    showEndOrBeginning() {
      return this.showSlidePreBegin || this.showSlidePostEnding;
    },
    visitedStyleObject() {
      return {
        background: `${this.siteSettings.accent} !important`
      };
    }
  },
  methods: {
    ...mapMutations(["stepButtonClicked"]),
    goToStep(stepId) {
      this.stepButtonClicked(stepId);
    },
    unwindVisitedSteps(stepId) {
      this.steps.forEach(step => {
        if (step > stepId) {
          this.visitedSteps.delete(step);
        } else if (step < stepId) {
          this.visitedSteps.add(stepId);
        }
      });
    }
  },
  mounted() {
    this.$root.slider = this.$refs.slider;
  },
  watch: {
    currentStep: {
      handler(stepId) {
        this.visitedSteps.add(stepId);
        this.unwindVisitedSteps(stepId);
        if (this.$refs && this.$refs.slider) {
          scrollToElement(this.$refs.slider, {
            behavior: "smooth",
            block: "start"
          });
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.sliderWrapper {
  width: 100%;
  .stepButtons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px;
    .stepButton {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      // background: #0b6a6e;
      background: #c4c4c4;
      margin: 5px;
    }
    // .visited {
    //   background: #0b6a6e !important;
    // }
  }

  .slide {
    width: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
}

.fade-enter-active {
  transition: all 0.5s;
}
.fade-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(30px);
}
</style>
